// extracted by mini-css-extract-plugin
export var copyableField = "_qv-4";
export var customerBadge = "_qv-0";
export var customerInfoTitle = "_qv-2";
export var details = "_qv-1";
export var dropdownContainer = "_qv-5";
export var dropdownImage = "_qv-6";
export var editAssigneeForm = "_qv-a";
export var editButton = "_qv-3";
export var email = "_qv-7";
export var hidden = "_qv-d";
export var input = "_qv-8";
export var saveButton = "_qv-b";
export var shopifyIcon = "_qv-c";
export var suggestionBadge = "_qv-e";
export var suggestionText = "_qv-f";
export var username = "_qv-9";